import { ref } from 'vue'

export const currentLang = ref(localStorage.getItem('hgs_lang') || 'zh')
